import { render, staticRenderFns } from "./ImageElement.vue?vue&type=template&id=4bea113a"
import script from "./ImageElement.vue?vue&type=script&lang=js"
export * from "./ImageElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports